<template>
  <div class="result">
    <p class="result__title">{{ title }}</p>
    <ul class="result__grid">
      <li v-for="(value, key) in data" :key="key" class="result__item">
        <p class="result__label">{{ labelMap[key] || key }}</p>
        <p class="result__value">
          {{ value !== null && value !== undefined ? value : "N/A" }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'calculator-result',
  data() {
    return {
      labelMap: {
        OptimumTurns: 'Optimum turns',
        WireAwg: 'Wire AWG (American Wire Gauge)',
        CoreOd: 'Core OD (mm)',
        CoreId: 'Core ID (mm)',
        CoreH: 'Core H (mm)',
        CoreVolume: 'Core volume (mm³)',
        CoreAl10Khz: 'Core AI @ 10 KHz (mH/1000 T)',
        CoreAl100Khz: 'Core AI @ 100 KHz (mH/1000 T)',
        Inductance: 'Inductance (mH)',
      },
    }
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.result {
  &__title {
    font-size: 1rem;
    line-height: 100%;
    font-weight: 700;
    color: #454545;
    margin-bottom: 1rem;
    letter-spacing: 0.01em;

    @media screen and (min-width: 768px) {
      margin-bottom: 1.5rem;
    }
  }

  &__grid {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media screen and (min-width: 768px) {
      gap: 1.5rem;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  &__label {
    font-weight: 400;
    color: #737373;
    font-size: 0.875rem;
    line-height: 100%;
    letter-spacing: 0.01em;
  }

  &__value {
    font-weight: 700;
    color: #454545;
    font-size: 0.875rem;
    line-height: 100%;
  }
}
</style>
